<template>
	<div class="nk-card" style="height: 440px">
		<div style="height:100%">
			<nk-table v-model="selectedRow" :data="frequentDescriptions" :options="componentOptions.tableOptions" :tabindex="102" ref="frequentDescriptionsTable"></nk-table>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters, mapActions } from 'vuex'
	import validators from '~/statics/validators.js'
	import Input from '~/components/general/nikan-input.vue'
	import EmptyId from '~/statics/empty-id'

	export default {
		modal: {
			size: 'md',
			stateUID: 'frequent-descriptions',
		},
		props: {
			data: { type: Object },
			options: {
				type: Object,
				default: () => {
					return {}
				},
			},
		},
		data() {
			return {
				addClicked: false,
				settings: {},
				frequentDescriptions: [],
				componentOptions: {
					tableOptions: {
						editable: true,
						allowNewRow: true,
						searchBarEnabled: true,
						sortable: true,
						buttons: {
							addBtn: {
								options: {
									visible: true
								}
							},
							deleteBtn: {
								options: {
									visible: true
								}
							}
						},
						prepareNewRow: () => {
							return {
								text: '',
								companyId: EmptyId,
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								type: 'number',
								width: '50px',
								pinnable: false,
								pinned: true,
								entering: false,
								leaving: true,
							},
							{
								name: 'text',
								title: this.$t('frequent-descriptions.f.description'),
								type: 'string',
								width: '400px',
								align: 'right',
								editable: true,
								type: 'string',
								serachable: true,
								view: {
									options: {
										format: (item) => item,
									},
								},
								edit: (row, col) => {
									return {
										component: Input,
										options: {
											mode: 'string',
										},
									}
								},
								validators: validators('required'),
								entering: true,
								leaving: true,
							},
						],
					},
					btnAdd: {
						title: this.$t('new-row'),
						isPrimary: false,
						icon: 'plus',
						tooltipEnabled: true,
						hideTitle: true,
					},
					btnDelete: {
						title: this.$t('delete-row'),
						icon: 'trash',
						isOutlineDanger: true,
						tooltipEnabled: true,
						hideTitle: true,
					},
				},
				selectedRow: null,
			}
		},
		computed: {
			...mapGetters({
				allFrequentDescriptions: 'frequentdescriptions/all',
			}),
		},
		created() {
			this.settings = _.extend({}, this.settings, this.options)
		},
		mounted() {
			this.frequentDescriptions = this.allFrequentDescriptions.filter(item => (item.entityId === this.options.entityId && item.entityType === this.options.entityType) || !item.entityId)
			this.selectedRow = this.data
		},
		methods: {
			newDescriptions() {
				return this.$refs.frequentDescriptionsTable
					.commitChanges()
					.then((data) => {
						let tmp = {
							entityId: this.options.entityId,
							entityType: this.options.entityType,
						}
						for (let index = 0; index < data.length; index++) {
							Object.assign(data[index], tmp)
						}
						return data
					})
			},
		},
	}
</script>
<style></style>
